var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgThreeUpcoming = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 10.5,
    stroke: "#8E93A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9474 21.132C19.0354 21.132 20.2714 20.112 20.2714 18.504C20.2714 17.412 19.5994 16.704 18.6034 16.488C19.4554 16.188 20.0194 15.588 20.0194 14.628C20.0194 13.284 18.9154 12.3 17.0314 12.3C15.0754 12.3 13.9594 13.452 13.8634 15.024H15.5794C15.6754 14.22 16.1794 13.728 16.9954 13.728C17.7874 13.728 18.1834 14.184 18.1834 14.796C18.1834 15.528 17.7754 15.936 16.8754 15.936H16.2514V17.232H16.9234C17.8474 17.232 18.3034 17.652 18.3034 18.468C18.3034 19.236 17.8474 19.704 16.8754 19.704C15.8434 19.704 15.3994 19.104 15.3274 18.276H13.5754C13.6474 20.016 14.7634 21.132 16.9474 21.132Z",
    fill: "#8E93A0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThreeUpcoming, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/three-upcoming.1a5d75d8.svg";
export { ForwardRef as ReactComponent };